import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import HeaderInstitutions from "./HeaderInstitutions";

import axios from "axios";

import LayersIcon from "@mui/icons-material/Layers";

import CardMembershipIcon from "@mui/icons-material/CardMembership";
import { api } from "../../../services/axios";

const InstitutionsDashboard = () => {
  const navigate = useNavigate();

  let token = localStorage.getItem("token");
  const [summary, setSummary] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!token) {
      navigate("/login");
      return;
    }

    const fetchSummary = async () => {
      try {
        const res = await api.get("/certificates/home", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setSummary(res.data);
      } catch (err) {
        console.error("Failed to fetch summary:", err);
        setError("Failed to load certificates");
      }
    };

    fetchSummary();
  }, [token, navigate]);

  if (error) return <p className="text-red-500">{error}</p>;
  if (!summary) {
    return (
      <div className="flex justify-center items-center py-10">
        <div className="w-10 h-10 border-4 border-[#095918] border-t-transparent rounded-full animate-spin"></div>
      </div>
    );
  }

  return (
    <div className="content flex-grow">
      <div className="inner-content">
        <HeaderInstitutions />
        <div className="p-4" style={{ backgroundColor: "#F6F7FB" }}>
          <div className="text-black p-4 flex  text-xl">
            <div>
              <LayersIcon className="mr-4" />
            </div>
            Dashboard
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-3 gap-6">
            <div
              className="rounded-lg p-4 flex-1 m-2 flex-col text-black"
              style={{ backgroundColor: "#FFE5D3" }}
            >
              <h1
                style={{ fontSize: "32px", fontWeight: "bold" }}
                className="py-2"
              >
                {summary.totalCount}
              </h1>
              <div className="flex">
                <div>
                  <CardMembershipIcon className="mr-4" />
                </div>
                Certificates generated
              </div>
            </div>
          </div>
        </div>

        <div className="p-6">
          <h2 className="text-xl font-bold mb-4">Certificates Summary</h2>

          <div className="mb-4 flex gap-6">
            <span>
              Generated Today: <strong>{summary.todayCount}</strong>
            </span>
          </div>

          <table className="min-w-full divide-y divide-gray-200 rounded-lg overflow-hidden shadow">
            <thead className="bg-[#095918] text-white">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider">
                  Full Name
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider">
                  Program
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider">
                  Certificate
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider">
                  CGPA
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider">
                  Verify
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider">
                  Issued
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {summary.latest.map((row) => (
                <tr key={row.certificate_id}>
                  <td className="px-6 py-4">{row.full_name}</td>
                  <td className="px-6 py-4">{row.program}</td>
                  <td className="px-6 py-4">{row.certificate}</td>
                  <td className="px-6 py-4">{row.cgpa}</td>
                  <td className="px-6 py-4">
                    <a
                      href={row.verify_url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-blue-600 hover:underline"
                    >
                      Verify
                    </a>
                  </td>
                  <td className="px-6 py-4">
                    {new Date(row.created_at).toLocaleDateString()}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default InstitutionsDashboard;
